import { Activity, ActivityType } from '@/components/features/Activity/utils';
import { ChakraComponent, ChakraProps, IconProps } from '@chakra-ui/react';
import { FlameIcon, ListedIcon, MintIcon, OfferIcon, SaleIcon, TransferIcon } from '@sphere/icons';
import { rem } from 'polished';

type Props = ChakraProps &
  IconProps & {
    type: ActivityType | 'burn';
  };

const iconMap: {
  [key in ActivityType | 'burn']: ChakraComponent<'svg', IconProps>;
} = {
  [Activity.ask]: ListedIcon,
  [Activity.ask_cancel]: ListedIcon,
  [Activity.mint]: MintIcon,
  [Activity.bid]: OfferIcon,
  [Activity.bid_cancel]: OfferIcon,
  [Activity.sale]: SaleIcon,
  [Activity.transfer]: TransferIcon,
  burn: FlameIcon,
};

export const ActivityEventIcon = ({
  boxSize = rem(20),
  color = 'inherit',
  type,
  ...props
}: Props) => {
  const Icon = iconMap[type] ?? null;
  if (!Icon) return null;

  return <Icon color={color} boxSize={boxSize} {...props} />;
};
